// extracted by mini-css-extract-plugin
module.exports = {"taskDetailsCell":"style_taskDetailsCell__NcVrA","blockIcon":"style_blockIcon__1TcBR","cell":"style_cell__5CTZS"};